document.querySelectorAll('[data-product-back-link]').forEach((link) => {
  link.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !document.referrer) return;

    const referrer = new URL(document.referrer);
    const current = new URL(window.location.href);
    const isCollectionPage = referrer.pathname.includes('/collections/') && !referrer.pathname.includes('/products/');
    const isArchivePage = /\/collections\/archive\/?$/.test(referrer.pathname);
    const scope = link.dataset.productBackScope;
    const canUseHistory = referrer.origin === current.origin
      && isCollectionPage
      && (scope === 'archive' ? isArchivePage : !isArchivePage);

    if (!canUseHistory) return;

    event.preventDefault();
    window.history.back();
  });
});
